<template lang="pug">
AppDialog.timesheet-confirm-dialog(
  title="Warning"
  append-to-body
  :show="show"
  @close="$emit('cancel')"
)
  i.fa.fa-warning.warning-icon

  p(v-if="multipleSheets")
    | You are about to submit timesheets in the current pay period.
    br
    strong You will not be able to track time until the day after your timesheets are approved.

  p(v-else)
    | You are about to submit a timesheet in the current pay period.
    br
    strong You will not be able to track time until the day after your timesheet is approved.

  template(slot="footer")
    AppButton(@click="$emit('cancel')")
      | Cancel

    AppButton(
      type="primary"
      @click="$emit('submit')"
    )
      | Submit anyway
</template>

<script>
export default {
  name: 'TimesheetSubmitConfirmDialog',
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    multipleSheets: {
      type: Boolean,
      required: true,
    },
  },
};
</script>
